import { Stack } from 'expo-router';
import Head from 'expo-router/head';
import React from 'react';

import { OffersAndRewardsScreen } from '@fhs/loyalty';
import { useShouldShowSectionsHeader } from '@fhs/loyalty/src/screens/offers-and-rewards/hooks';
import { ErrorBoundary, ErrorCard, VisuallyHiddenH1, useMqSelect } from '@fhs/ui';

import { getScreenTitleHeader } from '../get-screen-title-header';

type OffersAndRewardsPageProps = {
  isTabRoute?: boolean;
};

export function OffersAndRewardsPage({ isTabRoute = false }: OffersAndRewardsPageProps) {
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);
  const shouldShowSectionsHeader = useShouldShowSectionsHeader();

  return (
    <>
      <Head>
        <title>Loyalty - Firehouse Subs</title>
      </Head>
      {isDesktop && <VisuallyHiddenH1 title="Loyalty" />}
      <Stack.Screen
        options={{
          header: getScreenTitleHeader({
            cannotGoBackHref: isTabRoute ? '/' : '/menu',
            closeBehavior: isTabRoute ? 'tabHistory' : 'dismissTo',
            showDivider: !shouldShowSectionsHeader,
          }),
          headerShown: !isDesktop,
          title: 'Loyalty',
        }}
      />
      <ErrorBoundary fallback={<ErrorCard />}>
        <OffersAndRewardsScreen />
      </ErrorBoundary>
    </>
  );
}
